import {Injectable} from '@angular/core';
import {ConfigurationManager} from "../../../../store/configuration-manager/configuration-manager";
import {Observable, of, throwError} from "rxjs";
import {
  emptyIROperation,
  emptyIROperationParameter,
  emptyIROperationProfile,
  emptyIRTask,
  emptyIRTaskLog,
  emptyIRTaskParameter,
  emptyReportTemplate,
  IExportDefinitionItem,
  IReportTemplate,
  IROperation,
  IROperationParameter,
  IRTask,
  IRTaskLog,
  IRTaskParameter
} from "@retail-data-factory/rdf-angular-types-api";
import * as moment from "moment";
import {DataService} from "../../../../services/external-api/data.service";
import {catchError, map} from "rxjs/operators";
import {Presenter} from "../../../internal/presenter/presenter";
import {Tasks_Mdm_Demo} from "./mock-data/tasks_mdm";
import {IServiceResponse} from "../../../../services/external-api/response-interfaces";
import {IListItem} from "@retail-data-factory/rdf-angular-types-components";
import {HttpClient} from "@angular/common/http";
import {SpinnerService} from "@retail-data-factory/rdf-angular-utils";


@Injectable({
  providedIn: 'root'
})
export class ApiReportingService {

  constructor(
    private configurationManager: ConfigurationManager,
    private dataService: DataService,
    private presenter: Presenter,
    private spinnerService: SpinnerService,
    private http: HttpClient
  ) {
  }

  /**
   * Поиск задачи по параметрам
   * @param dateFrom дата с
   * @param dateTo дата по
   * @param operationCode код операции
   * @param operationParam массив параметров {code: string; value: string}
   * @param limit
   * @param offset
   */
  searchTask(dateFrom: Date, dateTo: Date, operationCode: string, operationParam: Array<{ code: string; value: string }>, limit = 50, offset = 0): Observable<Array<IRTask>> {
    const body = {
      date_from: dateFrom ? moment(dateFrom).format('YYYYMMDD') : '',
      date_until: dateTo ? moment(dateTo).format('YYYYMMDD') : '',
      operation_code: operationCode,
      operation_param: operationParam
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/tasks/search?limit=${limit}&offset=${offset}`, {}, body).pipe(
      map(result => {
        console.log(result);
        const tasks: Array<IRTask> = result.report.map(item => this.mapTaskFromService(item));
        return tasks;
      })
    );

  }

  searchTaskNoSpinner(dateFrom: Date, dateTo: Date, operationCode: string, operationParam: Array<{ code: string; value: string }>, limit = 50, offset = 0): Observable<Array<IRTask>> {

    const header = {
      "access_token": this.presenter.accessToken,
    }

    const body = {
      date_from: dateFrom ? moment(dateFrom).format('YYYYMMDD') : '',
      date_until: dateTo ? moment(dateTo).format('YYYYMMDD') : '',
      operation_code: operationCode,
      operation_param: operationParam
    };

    return this.http.post(`${this.configurationManager.getApiUrl('apiReportingUrl')}/tasks/search?limit=${limit}&offset=${offset}`, body, {headers: header})
      .pipe(
        map(
          (response: any) => {
            const tasks: Array<IRTask> = response.report.map(item => this.mapTaskFromService(item));
            return tasks;
          }
        ),
        catchError((e, caught) => {
          console.error(e);
          return throwError(e);
          //return of(null);
        })
      );
  }

  getTasks(dateFrom: Date, dateTo: Date, operationId = '', limit = 50, offset = 0, search = '', hideSpinner = false): Observable<Array<IRTask>> {
    const param = {
      datefrom: dateFrom ? moment(dateFrom).format('YYYYMMDD') : '',
      dateuntil: dateTo ? moment(dateTo).format('YYYYMMDD') : '',
      operation_id: operationId
    };
    // if (
    //   this.presenter.currentPartyId ==='1000' ||
    //   this.presenter.currentPartyId ==='1006'
    // ) {
    //   switch (this.presenter.currentPartyId) {
    //     case "1000": return of(Tasks_Mdm_Demo.map(item => this.mapTaskFromService(item)));
    //     case "1006": return of(Tasks_Mdm_Demo_rd.map(item => this.mapTaskFromService(item)));
    //     default: return of([]);
    //
    //   }
    //
    // }else {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/tasks?limit=${limit}&offset=${offset}&search=${search}`, param, [], hideSpinner).pipe(
      map(result => {
        console.log(result);
        const tasks: Array<IRTask> = result.report.map(item => this.mapTaskFromService(item));
        return tasks;
      })
    );
//    }

  }

  getTask(taskId: string): Observable<IRTask> {
    if (this.presenter.currentPartyId === '1000') {
      const item = Tasks_Mdm_Demo.find(t => t.ID === taskId);
      return of(this.mapTaskFromService(item));
    } else {
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/tasks/${taskId}`, {}).pipe(
        map(result => {
          if (result.report.length > 0) {
            const task: IRTask = this.mapTaskFromService(result.report[0]);
            return task;
          } else {
            return {...emptyIRTask};
          }
        })
      );
    }
  }

  getTaskFile(rid: string, datasourcePartyId: string) {
    const requestParameters = {};
    requestParameters['access_token'] = this.presenter.accessToken;
    requestParameters['access-token'] = this.presenter.accessToken;
    requestParameters['datasourcepartyid'] = datasourcePartyId;
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiReportingUrl') + '/tasks/' + rid + '/files', requestParameters);
  }


  createTask(operationCode, param: object): Observable<IServiceResponse> {
    const header = {
      'operation_code': operationCode
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/tasks`, header, param);
  }

  getTaskLogOutput(taskId: string, type?: string): Observable<Array<IRTaskLog>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/tasks/${taskId}/logs` + (type === 'out' ? '?type=out' : ''), {}).pipe(
      map(result => {
        const logs: Array<IRTaskLog> = result.report.map(item => this.mapLogOutputFromService(item));
        return logs;
      })
    );
  }

  getTaskParameters(taskId: string): Observable<Array<IRTaskParameter>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/tasks/${taskId}/parameters`, {}).pipe(
      map(result => {
          const parameters: Array<IRTaskParameter> = result.report.map(item => (
            {
              ...emptyIRTaskParameter,
              name: item['param_name'],
              value: item['param_value'],
              type: item['type']
            }));
          return parameters;
        }
      )
    );
  }

  getOperations(): Observable<Array<IROperation>> {
    return this.dataService.getReportData(this.configurationManager.getApiUrl('apiReportingUrl') + '/operations', {}).pipe(
      map(result => {
        const operations: Array<IROperation> = result.report.map(item => this.mapOperationFromService(item));
        return operations;
      })
    );
  }

  getOperation(operationId: string): Observable<IROperation> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/operations/${operationId}`, {}).pipe(
      map(result => {
        if (result.report.length) {
          return this.mapOperationFromService(result.report[0]);
        } else {
          return {...emptyIROperation};
        }
      })
    );
  }

  createOperation(operation: IROperation): Observable<IServiceResponse> {
    const param = this.mapOperationToService(operation);
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/operations`, {}, param);
  }

  updateOperation(operation: IROperation): Observable<IServiceResponse> {
    const param = this.mapOperationToService(operation);
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/operations/${operation.id}`, {}, param);
  }

  saveOperation(operation: IROperation): Observable<IServiceResponse> {
    return operation.id ? this.updateOperation(operation) : this.createOperation(operation);
  }


  getOperationParameters(operationId: string): Observable<Array<IROperationParameter>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/operations/${operationId}/parameters`, {}).pipe(
      map(result => {
        const parameters: Array<IROperationParameter> = result.report.map(item => ({
          ...emptyIROperationParameter,
          id: item['operation_param_id'].toString(),
          name: item['operation_param_name'] ? item['operation_param_name'] : '',
          default: item['operation_param_default'] ? item['operation_param_default'] : '',
          withoutFall: item['operation_param_withoutfall'] ? item['operation_param_withoutfall'] : 0
        }));
        return parameters;
      })
    );
  }

  createOperationParameters(operation: IROperation, parameters: Array<IROperationParameter>): Observable<IServiceResponse> {
    const param = {
      parameters: this.mapOperationParametersToService(parameters)
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/operations/${operation.id}/parameters`, {}, param);
  }

  updateOperationParameters(operation: IROperation, parameters: Array<IROperationParameter>): Observable<IServiceResponse> {
    const param = {
      parameters: this.mapOperationParametersToService(parameters)
    };
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/operations/${operation.id}/parameters`, {}, param);
  }

  deleteOperationParameter(operation: IROperation, parameterId: string): Observable<IServiceResponse> {
    //const param = this.mapOperationParametersToService(operation.parameters);
    return this.dataService.deleteData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/operations/${operation.id}/parameters/${parameterId}`, {}, '');
  }

  saveOperationParameters(operation: IROperation, parameters: Array<IROperationParameter>): Observable<IServiceResponse> {
    return operation.id ? this.updateOperationParameters(operation, parameters) : this.createOperationParameters(operation, parameters);
  }


  getReportTemplates(): Observable<Array<IReportTemplate>> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/templates`, {}).pipe(
      map(result => {
        const templates: Array<IReportTemplate> = result.report.map(item => this.mapReportTemplateFromService(item));
        return templates;
      })
    );
  }

  getReportTemplate(templateId: string): Observable<IReportTemplate> {
    return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/templates/${templateId}`, {}).pipe(
      map(result => {
        if (result.report.length > 0) {
          const template: IReportTemplate = this.mapReportTemplateFromService(result.report[0]);
          return template;
        } else {
          return {...emptyReportTemplate};
        }
      })
    );
  }

  createTemplate(template: IReportTemplate): Observable<IServiceResponse> {
    return this.dataService.postData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/templates`, {}, template);
  }

  updateTemplate(template: IReportTemplate): Observable<IServiceResponse> {
    return this.dataService.putData(`${this.configurationManager.getApiUrl('apiReportingUrl')}/templates/${template.id}`, {}, template);
  }

  saveTemplate(template: IReportTemplate): Observable<IServiceResponse> {
    return template.id ? this.updateTemplate(template) : this.createTemplate(template);
  }

  downloadTemplate() {

  }

  /**
   * Полученеие файла по шаблону
   * @param templateName название шаблона
   * @param exportDefinitionArray
   */
  getExcelReportFromTemplate(templateName: string, exportDefinitionArray: Array<IExportDefinitionItem>): Observable<Blob> {
    const header = {
      "access_token": this.presenter.accessToken,
    }
    const body = {
      "template_name": templateName,
      "template_data": exportDefinitionArray
    };
    this.spinnerService.show();
    return this.http.post(`${this.configurationManager.getApiUrl('apiReportingUrl')}/excel`, body, {
      headers: header,
      responseType: "blob"
    })
      .pipe(
        map(
          (response: any) => {
            this.spinnerService.hide();
            let dataType = response.type;
            let binaryData = [];
            binaryData.push(response);
            const result = new Blob(binaryData, {type: dataType});

            return result;
          }
        ),
        catchError((e, caught) => {
          console.error(e);
          this.spinnerService.hide();
          return throwError(e);
          //return of(null);
        })
      );
    /*      .subscribe(
          (response: any)=>{
            let dataType = response.type;
            let binaryData = [];
            binaryData.push(response);
            let downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
            downloadLink.setAttribute('download', 'filename.xlsx');
            document.body.appendChild(downloadLink);
            downloadLink.click();
          }
        );

    */
  }


  mapReportTemplateFromService(item): IReportTemplate {
    const reportTemplate: IReportTemplate = {
      ...emptyReportTemplate,
      id: item['id'] ? item['id'].toString() : '',
      partyId: item['party_id'] ? item['party_id'].toString() : '',
      type: item['type'],
      name: item['name'],
      description: item['description'],
      profile: item['profile']
    };
    return item;

  }

  decodePhaseName(phaseCode: string): string {
    switch (phaseCode) {
      case '0':
        return 'Ожидание';
      case '1':
        return 'В очереди';
      case '2':
        return 'Выполняется';
      case '3':
        return 'Выполнен';
      default:
        return 'Не известен';
    }
  }

  decodeStatusName(phaseCode: string, statusCode: string): string {
    switch (statusCode) {
      case '0':
        return phaseCode === '3' ? 'Успешно' : 'Нормальный';
      case '1':
        return 'Ошибка';
      default:
        return 'Не известен';
    }
  }

  mapTaskFromService(item: object): IRTask {
    const task: IRTask = {
      ...emptyIRTask,
      rid: item['ID'],
      dateSend: item['DateSubmited'] ? moment(item['DateSubmited'], 'DD.MM.YYYY HH:mm:ss').toDate() : null,
      dateStart: item['DateStarted'] ? moment(item['DateStarted'], 'DD.MM.YYYY HH:mm:ss').toDate() : null,
      dateEnd: item['DateExecuted'] ? moment(item['DateExecuted'], 'DD.MM.YYYY HH:mm:ss').toDate() : null,
      phaseCode: item['Phase'],
      endCode: item['EndCode'],
      statusCode: item['Status'],
      parametersStr: item['OprParams'],
      description: item[''],
      operationCode: item['OprCode'],
      operationName: item['OprName'],
      userLogin: item['UserLogin'],
      profile: item['profile'],
      scheduleTypeCode: item['ScheduleType'],
      url: item['URL'],
      parentRid: item['ParentId'],
      parameters: []
    };
    return task;
  }

  mapOperationFromService(item: object): IROperation {
    const operation: IROperation = {
      ...emptyIROperation,
      id: item['operation_id'].toString(),
      code: item['operation_code'],
      name: item['operation_name'],
      folder: item['operation_folder'],
      filename: item['operation_filename'],
      priority: item['operation_priority'],
      simultaneous: item['operation_simultaneous'] === 1,
      type: item['operation_type'] !== null && item['operation_type'] !== undefined ? item['operation_type'].toString() : '',
      defaultTaskProcessor: item['default_taskproc'],
      defaultTaskProcessorId: item['default_taskproc_id'] ? item['default_taskproc_id'].toString() : '',
      fileTemplate: item['file_template'],
      urlTemplate: item['url_template'],
      taskProcessorGroupId: item['taskproc_group_id'] ? `${item['taskproc_group_id']}` : '',
      weight: item['processor_weigth'],
      deleted: item['deleted'] === 1,
      maxRunCount: item['max_run_count'],
      profile: {
        ...emptyIROperationProfile,
        ...item['profile']
      }
    };
    return operation;
  }

  mapOperationToService(item: IROperation): object {
    console.log(item);
    const operation = {
      operation_id: item.id,
      operation_code: item.code,
      operation_name: item.name,
      operation_folder: item.folder,
      operation_filename: item.filename,
      operation_priority: item.priority,
      operation_simultaneous: item.simultaneous ? '1' : '0',
      operation_type: item.type,
      default_taskproc: item.defaultTaskProcessor,
      default_taskproc_id: item.defaultTaskProcessorId,
      file_template: item.fileTemplate,
      url_template: item.urlTemplate,
      taskproc_group_id: item.taskProcessorGroupId,
      processor_weigth: item.weight,
      deleted: item.deleted ? '1' : '0',
      max_run_count: item.maxRunCount,
      profile: item.profile,
      operation_params: this.mapOperationParametersToService(item.parameters)
    };
    return operation;
  }

  mapOperationParametersToService(params: Array<IROperationParameter>): Array<any> {
    return params.map(item => ({
        operation_param_id: item.id,
        operation_param_name: item.name,
        operation_param_default: item.default,
        operation_param_withoutfall: item.withoutFall
      })
    );
  }

  mapLogOutputFromService(item: object): IRTaskLog {
    const log: IRTaskLog = {
      ...emptyIRTaskLog,
      id: item['log_id'] ? item['log_id'].toString() : '',
      text: item['log_text'],
      rid: item['log_rid'] ? item['log_rid'].toString() : '',
      date: item['log_date'] ? moment(item['log_date'], 'YYYYMMDD HH:mm:ss').toDate() : null
    };
    return log;
  }

  mapTaskParametersFromList(task: IRTask, list: Array<IListItem>, type: 'request' | 'common') {
    task.parameters = task.parameters.filter(t => t.type !== type);
    list.forEach(t => {
      task.parameters.push({name: t.code, value: t.text, type: type});
    });


  }

  decodeStatusNameTranslated(phaseCode: string, errorCode: string, lang: string, duration: number = 0): string {
    let result = '';
    //if (lang !== 'ro') {
    switch (lang) {

      case 'en':
        switch (phaseCode) {
          case '0':
            result = 'Pending';
            break;
          case '1':
            result = 'Queue';
            break;
          case '2':
            result = 'Executing';
            break;
          case '3':
            result = 'Finished';
            break;
          case '4':
            result = 'Canceled';
            break;
          case '5':
            result = 'Canceled';
            break;
          case '6':
            result = 'прерван';
            break;
          default:
            result = 'Other';
        }
        if (phaseCode === '3' && errorCode === '1') {
          result = 'Finished with error';
        }
        break;

      case 'ro':
        switch (phaseCode) {
          case '0':
            result = 'Astepta';
            break;
          case '1':
            result = 'Este realizat';
            break;
          case '2':
            result = 'Pregatire';
            break;
          case '3':
            result = 'Pregatit';
            break;
          case '4':
            result = 'Canceled';
            break;
          case '5':
            result = 'Canceled';
            break;
          case '6':
            result = 'прерван';
            break;
          default:
            result = 'Other';
        }
        if (phaseCode === '3' && errorCode === '1') {
          result = 'Eroare';
        }
        if (phaseCode === '3' && errorCode === '0' && duration > 6) {
          result = 'Sters';
        }
        break;

      case 'ru':
        switch (phaseCode) {
          case '0':
            result = 'В ожидании';
            break;
          case '1':
            result = 'В очереди';
            break;
          case '2':
            result = 'Выполняется';
            break;
          case '3':
            result = 'Завершено';
            break;
          case '4':
            result = 'Отменено';
            break;
          case '5':
            result = 'Отменено';
            break;
          case '6':
            result = 'Прервано';
            break;
          default:
            result = 'Другое';
        }
        if (phaseCode === '3' && errorCode === '1') {
          result = 'Ошибка';
        }
        break;

      case 'ua':
        switch (phaseCode) {
          case '0':
            result = 'В очікуванні';
            break;
          case '1':
            result = 'В черзі';
            break;
          case '2':
            result = 'Виконується';
            break;
          case '3':
            result = 'Завершено';
            break;
          case '4':
            result = 'Відмінено';
            break;
          case '5':
            result = 'Відмінено';
            break;
          case '6':
            result = 'прерван';
            break;
          default:
            result = 'Другий';
        }
        if (phaseCode === '3' && errorCode === '1') {
          result = 'Помилка';
        }
        break;

      default:
        switch (phaseCode) {
          case '0':
            result = 'Pending';
            break;
          case '1':
            result = 'Queue';
            break;
          case '2':
            result = 'Executing';
            break;
          case '3':
            result = 'Finished';
            break;
          case '4':
            result = 'Canceled';
            break;
          case '5':
            result = 'Canceled';
            break;
          case '6':
            result = 'прерван';
            break;
          default:
            result = 'Other';
        }
        if (phaseCode === '3' && errorCode === '1') {
          result = 'Finished with error';
        }
    }

    return result;
  }

  decodeStatusColor(phaseCode: string, errorCode: string) {

    switch (phaseCode) {
      case '0':
        return '#489ac9'; // бирюзовый
      case '1':
        return '#dcb852'; // желтый
      case '2':
        return '#386077'; // синий
      case '3':
        if (errorCode === '1') {
          return '#dd2222'; // красный
        }
        return '#98d19e'; // зеленый
      case '4':
        return '#b6c0d4'; // серый
      case '5':
        return '#b6c0d4'; // серый
      case '6':
        return '#dd2222'; // красный
      default:
        return '#b6c0d4'; // серый
    }
  }

  /*
    getTasks(processType: string, searchString?: string, groupId?:string): Observable<Array<IWorkflowTask>> {
    const param = {
      process_type: processType ? processType : '-',
      //procType: '-',
      group_id: groupId ? groupId : '-'
    };
    if (searchString) {
      param['search_filter'] = searchString;
    }
    if (this.configurationManager.theme === 'unicredit') {
      const tasks: Array<IWorkflowTask> = MockWorkflowTasks.report.map(item => this.mapTaskFromService(item));
      return of(tasks);
    } else {
      console.log(param);
      return this.dataService.getReportData(`${this.configurationManager.getApiUrl('apiWorkflowUrl')}/tasks`, param).pipe(
        map(result => {
          console.log(result);
          const tasks: Array<IWorkflowTask> = result.report.map(item => this.mapTaskFromService(item));
          return tasks;
        })
      );
    }

  }
   */


}
